export default function () {
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    return isSafari;
}